var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pagamentos',{attrs:{"dataServicos":_vm.obterDataServicos(),"rotaListagem":"Gescon_Gestores_Pagamentos","rotaDetalhar":"Gescon_Gestores_Pagamentos_Detalhar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }